import { Text, useNetworkState } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';
import { useLocation } from 'react-router';
import { Fade } from 'transitions-kit';

import { routes } from '~/client/config/routes';
import { useIsUserRegistered } from '~/client/hooks/authHooks';
import { useCurrentUser } from '~/client/hooks/storeHooks';
import { useAppStore } from '~/client/store/app/appStore';
import { useTinybaseStore } from '~/client/store/tinybase/tinybaseStore';

import { offlineCopy, syncingCopy } from './config';
import { DataSyncOverlayRoot } from './DataSyncOverlay.styled';
import { DataSyncProgress } from './DataSyncProgress';

const shouldHideOnCurrentPage = (pathname: string) =>
  ([routes.authRegistration] as string[]).includes(pathname);

export const DataSyncOverlay: FunctionComponent = () => {
  const { online } = useNetworkState();

  const { pathname } = useLocation();

  const currentUser = useCurrentUser();

  const needsClientAuth = useAppStore((state) => state.needsClientAuth);
  const hasCompletedInitialSync = useTinybaseStore((state) => state.hasCompletedInitialSync);

  const { isRegistered } = useIsUserRegistered();

  const showOverlay =
    currentUser && isRegistered && !hasCompletedInitialSync && !shouldHideOnCurrentPage(pathname);

  const copy = online ? syncingCopy : offlineCopy;

  return (
    <Fade in={showOverlay} unmountOnExit>
      <DataSyncOverlayRoot>
        <Text variant="h1">{copy.heading}</Text>
        <Text variant="lead">{copy.message}</Text>
        {online && (
          <DataSyncProgress hasStarted={!needsClientAuth} hasCompleted={hasCompletedInitialSync} />
        )}
      </DataSyncOverlayRoot>
    </Fade>
  );
};
